export default "__VITE_ASSET___nPErZrv__"